
import { defineComponent } from 'vue';
import store from '@/store';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import ExternalTransactionsTable from '@/components/transactionsComponents/ExternalTransactionsTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';
import PersianDatePicker from '@/components/appComponents/PersianDatePicker.vue';

export default defineComponent({
    name: 'TransactionsListPage',
    components: {
        IpgTransactionSkelton,
        ExternalTransactionsTable,
        CustomPaginationComponent,
        PersianDatePicker
    },
    data() {
        return {
            user: '',
            activeFilterButton: 'DEFAULT',
            buttons: [
                { title: 'پیش فرض', value: 'DEFAULT' },
                { title: 'شارژ', value: 'CHARGE' },
                { title: 'انتقال', value: 'TRANSFER' },
                { title: 'درگاه', value: 'DIRECT' },
                { title: 'برداشت', value: 'WITHDRAW' },
                { title: 'صورتحساب', value: 'INVOICE' },
                { title: 'OAuth', value: 'OAUTH' },
                { title: 'محصول', value: 'PRODUCT' },
                { title: 'ووچر', value: 'VOUCHER' },
            ],

            autoRefresh: false,
            startDateMenu: false,
            endDateMenu: false,
            refreshInterval: null as ReturnType<typeof setInterval> | null,

            filters: {
                startDate: null as string | null,
                endDate: null as string | null,
                type: null as 'CHARGE' | 'DEFAULT' | null,
                typeTool: null as 'CHARGE' | 'DEFAULT' | null,
                status: null as 'pending' | 'success' | 'failed' | null,
                take: 50,
                cursor: null as string | null,
            },

            gatewayOptions: ['pna', 'irankish', 'fanava'] as const,
            typeToolOptions: ['CHARGE', 'DEFAULT'] as const,
            statusOptions: ['pending', 'success', 'failed'] as const,

            downloading: false,
        };
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getExternalTransactions(): any[] {
            return store.getters['panel/getExternalTransactions'];
        },
        getTotalTransactionsAmount(): number {
            return store.getters['panel/getTotalTransactionsAmount'];
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
    },

    methods: {
        applyFilters() {
            const payload = { ...this.filters };
            store.dispatch('panel/getExternalTransactionsRequest', payload);
        },

        resetFilters() {
            this.filters = {
                startDate: null,
                endDate: null,
                type: null,
                typeTool: null,
                status: null,
                take: 50,
                cursor: null,
            };
            this.applyFilters();
        },

        handelPagination() {
            const params = { ...this.filters };
            store.dispatch('panel/getExternalTransactionsRequest', params);
        },

        setFilterOfExternalTransactions(type: string): void {
            const params = { ...this.filters };
            store.dispatch('panel/getExternalTransactionsRequest', params);
        },

        async downloadExcel() {
            this.downloading = true;
            const payload = { ...this.filters };

            store.dispatch("panel/getTransactionReportExcelRequest", payload);

            this.downloading = false;
        },
        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        changeAutoRefresh() {
            this.autoRefresh = !this.autoRefresh;
            if(this.autoRefresh) {
                this.refreshInterval = setInterval(() => {
                    this.applyFilters();
                }, 20000);
            } else if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        }
    },
    beforeUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    mounted() {
        const query = this.$route.query;
        if (query.startDate) this.filters.startDate = query.startDate as string;
        if (query.endDate) this.filters.endDate = query.endDate as string;
        if (query.type) this.filters.type = query.type as string;
        if (query.typeTool) this.filters.typeTool = query.typeTool as any;
        if (query.status) this.filters.status = query.status as any;
        if (query.take) this.filters.take = Number(query.take);

        this.applyFilters();
    },
});
